function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Layout, Menu, Drawer, Button, Space, Image, Badge, Modal, Avatar, notification } from 'antd';
import { XSquareFill, PersonPlusFill, MenuButtonWideFill, List, EmojiSmileFill, Cash } from 'react-bootstrap-icons';
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { Container, Col, Row } from 'react-bootstrap';
import NewCustomer from '../components/forms/NewCustomer';
import UserNavBar from '../components/navbars/UserNavBar';
import Common from '../components/includes/Common';
import Autorisations from '../components/Autorisations';
import InitiateCashout from '../components/forms/InitiateCashout';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Header = Layout.Header,
  Content = Layout.Content,
  Footer = Layout.Footer,
  Sider = Layout.Sider;
var Home = function Home() {
  var navigate = useNavigate();
  var _useParams = useParams(),
    userid = _useParams.userid;
  var _useState = useState(Common.currentUser),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    menuDrawerVisible = _useState4[0],
    setMenuDrawerVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    ncDrawerVisible = _useState6[0],
    setNcDrawerVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showRequests = _useState8[0],
    setShowRequests = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    dataChanged = _useState0[0],
    setDataChanged = _useState0[1];
  var _useState1 = useState(true),
    _useState10 = _slicedToArray(_useState1, 2),
    authProcessing = _useState10[0],
    setAuthProcessing = _useState10[1];
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    collapsed = _useState12[0],
    setCollapsed = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    requestsCount = _useState14[0],
    setRequestsCount = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showInitExpense = _useState16[0],
    setShowInitExpense = _useState16[1];
  useEffect(function () {
    var uid = localStorage.getItem("userData") != null && localStorage.getItem("userData") != "undefined" ? JSON.parse(localStorage.getItem("userData")).id : userid;
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: Common.currentUser != "undefined" ? Common.currentUser.id : null
    }).then(function (response) {
      setAuthProcessing(false);
      if (response.data.authenticated == 1) {
        setUser(response.data.user);
        localStorage.setItem('userData', JSON.stringify(response.data.user));
      } else {
        console.log("Auth Failed");
        navigate('/');
      }
    })["catch"](function (error) {});
    if (user == null) {
      setUser(JSON.parse(localStorage.getItem("userData")));
    }
  }, []);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getrequestscount/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) setRequestsCount(response.data.count);
    })["catch"](function (error) {})["finally"](function () {});
  }, [requestsCount]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: user != null ? /*#__PURE__*/_jsxs(Layout, {
      style: {
        minHeight: '100vh'
      },
      children: [/*#__PURE__*/_jsxs(Sider, {
        collapsible: true,
        collapsed: collapsed,
        onCollapse: function onCollapse(value) {
          return setCollapsed(value);
        },
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            height: 32,
            margin: 16,
            background: 'rgba(255, 255, 255, 0.2)'
          }
        }), /*#__PURE__*/_jsx(UserNavBar, {
          style: {
            background: "#2F5470"
          },
          handleMenuClose: function handleMenuClose() {
            setMenuDrawerVisible(false);
          }
        })]
      }), /*#__PURE__*/_jsxs(Layout, {
        className: "site-layout",
        children: [/*#__PURE__*/_jsx(Header, {
          className: "site-layout-background",
          style: {
            padding: 0
          },
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 3,
                xs: 4,
                children: /*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  children: /*#__PURE__*/_jsx(Image, {
                    preview: false,
                    width: "125px",
                    src: "drawables/emgl.png"
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: {
                  span: 4,
                  offset: 0
                },
                md: {
                  span: 4,
                  offset: 0
                },
                sm: {
                  span: 4,
                  offset: 0
                },
                xs: {
                  span: 5,
                  offset: 0
                },
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(EmojiSmileFill, {
                    size: 25
                  }), " ", user != null && ' ' + user.firstname, " , bonjour"]
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: {
                  span: 1,
                  offset: 2
                },
                md: {
                  span: 1,
                  offset: 2
                },
                sm: {
                  span: 2
                },
                xs: {
                  span: 2
                },
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Badge, {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: function onClick() {
                      setShowRequests(true);
                    },
                    count: requestsCount,
                    children: /*#__PURE__*/_jsx(Avatar, {
                      shape: "square",
                      size: "large"
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setShowInitExpense(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(Cash, {
                        size: 25
                      })
                    })
                  })]
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Content, {
          style: {
            margin: '0 16px',
            paddingTop: '30px'
          },
          children: /*#__PURE__*/_jsx(Outlet, {
            context: [dataChanged, setDataChanged]
          })
        }), /*#__PURE__*/_jsx(Footer, {
          style: {
            textAlign: 'center'
          },
          children: "GuisoftLab \xA92022 Tous droits r\xE9serv\xE9s"
        })]
      }), /*#__PURE__*/_jsx(Drawer, {
        visible: showRequests,
        width: "85%",
        title: /*#__PURE__*/_jsx("b", {
          children: "DEMANDES"
        }),
        destroyOnClose: true,
        onClose: function onClose() {
          setShowRequests(false);
        },
        closable: true,
        children: /*#__PURE__*/_jsx(Autorisations, {})
      }), /*#__PURE__*/_jsx(Modal, {
        visible: showInitExpense,
        width: "620px",
        title: /*#__PURE__*/_jsx("b", {
          children: "INITIER UNE SORTIE"
        }),
        destroyOnClose: true,
        onCancel: function onCancel() {
          setShowInitExpense(false);
        },
        footer: null,
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(InitiateCashout, {
            operationType: 0,
            handler: function handler() {
              setShowInitExpense(false);
              notification.success({
                message: "Ok!",
                description: "Opération envoyée pour validation"
              });
            }
          })
        })
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {})
  });
};
export default Home;